import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppStart from "./App_v2";
//import AppStart from "./AblyTest";
//import AppStart from "./AWSTest";
import AppStart2 from "./FileReducer";
import TestEmbeddedBrowser from "./TestEmbeddedBrowser";
//import AppStart2 from "./PDFTest2";
//import AppStart from "./ChatGPTTest";
//import AppStart from "./TimeEntry";
import reportWebVitals from "./reportWebVitals";
import { registerLicense } from "@syncfusion/ej2-base";

// Registering Syncfusion license key
registerLicense(
  "ORg4AjUWIQA/Gnt2XVhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5SdkBhWX5cdHVRQmdU",
);

// Top Step Prod clientid: 45210_cFKF10LBoqx1Syar  client secret: SHRK7LB0I4KU73Ag4zeDGPtP6G_Dm_oeQdg1XAJpx3m0aSXqHjh9M1Iq3-wxIRQqsbZRDCGj9OYuiSQjStSl2w
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const statusReportId = urlParams.get("srid");
console.log("Status Report Id: " + statusReportId);
if (statusReportId == "foobar") {
  window.location.href =
    "https://collab-center-documentation.s3.us-east-1.amazonaws.com/ADMINISTRATION+GUIDE.pdf";
} else {
  //console.log("Window.location: " + JSON.stringify(window.location));
  const host = window.location.hostname;
  const inject1 = ReactDOM.createRoot(document.getElementById("inject1"));
  if (host == "localhostt") {
    inject1.render(<TestEmbeddedBrowser />);
  } else {
    inject1.render(<AppStart />);
  }
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
